import { ErrorContainer, ErrorManager, FormFieldProps } from "../index";
import { getHolder } from "../Utils";


class DefaultErrorManager<X, XT> implements ErrorManager<X, XT> {
	readError( props: FormFieldProps<X, XT>, key: string ) {
		const holder = getHolder( props );
		let errorContainer: ErrorContainer = holder.readValue( "errorContainer" ) as any;
		if ( errorContainer && typeof errorContainer === "object" && errorContainer.hasOwnProperty( key ) ) {
			return errorContainer[ key ] as string;
		}
		return undefined;
	}

	writeError( props: FormFieldProps<X, XT>, key: string, value: string | undefined, callback?: () => void ) {
		const holder = getHolder( props );
		let errorContainer: ErrorContainer = holder.readValue( "errorContainer" ) as any;
		if ( errorContainer == null ) errorContainer = {};
		if ( value ) {
			errorContainer = {
				...errorContainer,
				[ key ]: value
			};
		} else {
			errorContainer = {
				...errorContainer,
			};
			delete errorContainer[ key ];
		}
		return holder.writeValue( "errorContainer", errorContainer as any, callback );
	}

}

export const defaultErrorManager = new DefaultErrorManager<any, any>();
